import { render, staticRenderFns } from "./AssetImage.vue?vue&type=template&id=e2bc54c6&"
import script from "./AssetImage.vue?vue&type=script&lang=js&"
export * from "./AssetImage.vue?vue&type=script&lang=js&"
import style0 from "./AssetImage.vue?vue&type=style&index=0&id=e2bc54c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports